{
	"title": "Hantera deklarationer",
	"createDeclaration": "Skapa deklaration"
}
